import { useState } from 'react';
import { PlusIcon, MinusIcon } from '@phosphor-icons/react';
import './styles.scss';

const QnASection = ({ section }) => {
    const { signatureTitle, signatureImage, personImage, qnAItems } = section;
    const [activeIndex, setActiveIndex] = useState(null);

    const handleItemClick = (index) => {
        setActiveIndex((prevIndex) => (prevIndex === index ? null : index));
    };

    // Sort Q&A items by sequence
    const sortedItems = qnAItems ? [...qnAItems].sort((a, b) => a.sequence - b.sequence) : [];

    // Extract person name from the first part of signatureTitle (e.g., "A Q&A with Tom" -> "Tom")
    const personName = signatureTitle ? signatureTitle.split(' ').pop() : '';

    return (
        <div className="qna-section">
            <div className="qna-content">
                <div className="qna-left">
                    {signatureTitle && <h2 className="qna-title">A Q&A with {personName}</h2>}

                    <div className="qna-items">
                        {sortedItems.map((item, index) => (
                            <div key={item.id} className="qna-item">
                                <button
                                    className={`qna-question ${activeIndex === index ? 'active' : ''}`}
                                    onClick={() => handleItemClick(index)}
                                >
                                    <span className="question-text">Q. {item.question}</span>
                                    {activeIndex === index ? <MinusIcon size={24} /> : <PlusIcon size={24} />}
                                </button>
                                <div
                                    className="qna-answer"
                                    style={{
                                        maxHeight: activeIndex === index ? '500px' : '0px',
                                    }}
                                >
                                    <div dangerouslySetInnerHTML={{ __html: item.answer }} />
                                </div>
                            </div>
                        ))}
                    </div>

                    <div className="qna-signature">
                        {personName && <p className="person-title">{personName}, Shop Manager</p>}
                        {signatureImage && (
                            <img
                                src={`${process.env.REACT_APP_WEBSITE_API}${signatureImage.url}`}
                                alt={`${personName} signature`}
                                className="signature-image"
                            />
                        )}
                    </div>
                </div>

                <div className="qna-right">
                    {personImage && (
                        <img
                            src={`${process.env.REACT_APP_WEBSITE_API}/api/images/optimize?filePath=images/hero/persons/${personImage.fileName}&width=600&height=800&quality=90&format=webp`}
                            alt={personName}
                            className="person-image"
                        />
                    )}
                </div>
            </div>
        </div>
    );
};

export default QnASection;
